<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <!--begin: User Bar -->
    <div class="d-flex align-items-center">
      <!-- Notification Bell -->
      <b-dropdown
        variant="link"
        toggle-class="topbar-item p-0"
        menu-class="p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg"
        no-caret
        right
      >
        <template #button-content>
          <div class="btn btn-icon btn-clean btn-lg btn-dropdown position-relative">
            <span class="svg-icon svg-icon-xl svg-icon-primary">
              <i class="flaticon2-bell-4 icon-lg text-muted" />
            </span>
            <span
              v-if="unreadCount > 0"
              class="label label-danger label-sm position-absolute"
              style="top: 6px; right: 6px; min-width: 16px; height: 16px; font-size: 10px;"
            >
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </div>
        </template>
        <b-dropdown-text>
          <DropdownNotification v-model="unreadCount" />
        </b-dropdown-text>
      </b-dropdown>

      <KTQuickUser />
    </div>
    <template v-if="isNewLayout"><KTMenuOptionsMore></KTMenuOptionsMore></template>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTQuickUser from '@/view/layout/extras/offcanvas/QuickUser.vue';
import KTMenuOptionsMore from '@/view/layout/header/_MenuOptionsMore.vue';
import DropdownNotification from '@/view/layout/extras/dropdown/DropdownNotification.vue';
import SavaDataUtil from '@/utils/saveDataToLocal';
import ApiService from '@/core/services/api.service';
import { listenNotifications } from '@/core/services/notification-listener.service';

export default {
  name: 'KTTopbar',
  components: {
    KTQuickUser,
    KTMenuOptionsMore,
    DropdownNotification,
  },
  data() {
    return {
      selectedMerchant: 1,
      merchantOptions: [
        { value: 1, text: 'Di Động Việt (DDV)' },
        { value: 2, text: 'Thế Giới Máy Cũ (TGMC)' },
      ],
      unreadCount: 0,
      unsubscribeFirestore: null,
    };
  },
  computed: {
    isNewLayout(){
      if (SavaDataUtil.getData('config')) return true;
      return false;
    },
  },
  mounted() {
    this.selectedMerchant = SavaDataUtil.getData('merchantId') || 1;
    this.fetchUnreadCount();
    this.unsubscribeFirestore = listenNotifications(() => {
      this.fetchUnreadCount();
    });
  },
  beforeDestroy() {
    if (this.unsubscribeFirestore) this.unsubscribeFirestore();
  },
  methods: {
    async fetchUnreadCount() {
      try {
        const res = await ApiService.query('notification-events/unread-count');
        const newCount = res.data.data.count || 0;
        this.unreadCount = newCount;
      } catch (err) {
        console.error('[Topbar] fetchUnreadCount error:', err);
      }
    },
    onChangeMerchant() {
      SavaDataUtil.saveData('merchantId', this.selectedMerchant);
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>
